import PropTypes from 'prop-types';
import { map } from 'lodash';
import { Box, Grid, Typography } from '@mui/material';

const OpenWindowList = ({ openWindows }) => (
  <Box id='OpenWindows' data-testid='OpenWindows'>
    <Grid container sx={{ width: '100%', flexDirection: 'column' }}>
      {map(openWindows, ({ day, openWindow }, index) => (
        <Grid container key={day}>
          <Grid sx={{ flexGrow: 1 }}>
            <Typography id={`OpenWindow-${day}`.replaceAll(' ', '')}>
              {day}
            </Typography>
          </Grid>
          <Grid sx={{ textAlign: 'end' }}>
            <Typography id={`OpenWindow-${index}`}>{openWindow}</Typography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  </Box>
);

OpenWindowList.propTypes = {
  openWindows: PropTypes.array,
};

export default OpenWindowList;
